module.exports = __webpack_public_path__ + "img/ppmi-logo-horiz.fa16d35b.png";